import React, { Component } from 'react';
// redux
import { compose } from 'redux';
import { submitRisk, getRiskQuestions } from '../../redux/reducers/recovery';
import { connect } from 'react-redux';
// hoc
import { withFormik } from 'formik';
import { withRouter } from 'react-router-dom';
// utils
import * as yup from 'yup';
import moment from 'moment';
import { toastResponseErrors } from '../../utils/response';
// components
import FieldError from '../../components/Form/FieldError';
import Datepicker from '../../components/Datepicker/Datepicker';
import Form from '../../components/Form/Form';
import Button from '../../components/Button/Button';
import CheckBox from '../../components/CheckBox/CheckBox';
import RadioGroup from '../../components/RadioGroup/RadioGroup';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import Preloader from '../../components/Preloader/Preloader';
// styles
import styles from './WeeklyCheckIn.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class WeeklyCheckIn extends Component {
  componentDidMount() {
    this.props.getRiskQuestions();
  }

  handleCheckboxChange = event => {
    const { riskQuestions, setValues, values } = this.props;
    const lastId = +riskQuestions.unshift();
    const currentId = +event.target.value;

    if (lastId === currentId && !values[lastId]) {
      const newValues = riskQuestions.reduce((acc, current) => {
        acc[current.id] = +current.id === lastId;
        return acc;
      }, values);
      setValues(newValues);
      return null;
    }

    setValues({
      ...values,
      [currentId]: !values[currentId],
      [lastId]: false
    });
  };

  dateOnChange = value => {
    const { setFieldValue } = this.props;
    setFieldValue('date', new Date(value.utc().format()));
  };

  dateOnBlur = () => {
    const { setFieldTouched } = this.props;
    setFieldTouched('date', true);
  };

  render() {
    const {
      isSubmitting,
      isLoading,
      values,
      handleSubmit,
      handleChange,
      errors,
      profile_color,
      riskQuestions,
      touched,
      clocks: { last_attempt_start, start }
    } = this.props;

    const userColor = profile_color || '#33C370';
    const lastTime = last_attempt_start
      ? moment(last_attempt_start).format('MM/DD/YY')
      : moment(start).format('MM/DD/YY');

    return (
      <PageWrapper centered>
        <h2>Weekly Check-in.</h2>
        <Preloader custom isActive={isLoading} />
        <Form className={cx('wrapper')} onSubmit={handleSubmit}>
          <div className="form-control">
            <div className="field-wrapper">
              <p>
                {`1. According to your recovery clock, your last time engaging in
              online sexual behavior was ${lastTime}, is this still correct?`}
              </p>
              <div className="field-wrapper">
                <RadioGroup
                  name="isCorrectDate"
                  onChange={handleChange}
                  value={values.isCorrectDate}
                  options={[
                    { label: 'Yes', value: 'true' },
                    { label: 'No', value: 'false' }
                  ]}
                />
                <FieldError error={errors.isCorrectDate} touched={true} />
              </div>
            </div>
          </div>

          {values.isCorrectDate === 'true' && (
            <div className="field-wrapper">
              <p>
                2. In the past week, have you experienced any of the common
                recovery challenges below? Check all that apply
              </p>
              <div className="field-wrapper">
                {riskQuestions.map(({ id, question }) => (
                  <CheckBox
                    className={cx('challenges')}
                    onChange={this.handleCheckboxChange}
                    key={id}
                    name={id}
                    value={id}
                    label={question}
                    checked={values[id]}
                  />
                ))}
              </div>
            </div>
          )}

          {values.isCorrectDate === 'false' && (
            <div>
              <h4>
                Thanks for your honesty, please reset your clock below (Continue
                to question 1a):
              </h4>
              <div className="field-wrapper">
                <div className={cx('date-container')}>
                  <Datepicker
                    color={userColor}
                    name="date"
                    selected={moment(values.date)}
                    onChange={this.dateOnChange}
                    onBlur={this.dateOnBlur}
                    invalid={errors.date}
                  />
                </div>
                <FieldError error={errors.date} touched={true} />
              </div>
              <div className="field-wrapper">
                <p>
                  1a. There are many reasons why it can be difficult to start or
                  maintain your efforts in recovery. We have made a module to
                  help users who have encountered some of these difficulties in
                  their recovery and need some additional support. Would you
                  like to begin this module after this check-in?:
                </p>
                <RadioGroup
                  name="shouldOpenRecovery"
                  onChange={handleChange}
                  value={values.shouldOpenRecovery}
                  options={[
                    { label: 'Yes', value: 'true' },
                    { label: 'No', value: 'false' }
                  ]}
                />
                <FieldError
                  error={errors.shouldOpenRecovery}
                  touched={touched.shouldOpenRecovery}
                />
              </div>
            </div>
          )}

          <div className={cx('button-section')}>
            <Button
              type="submit"
              color={userColor}
              disabled={isSubmitting || isLoading}
              className="mr-30"
            >
              Submit
            </Button>
          </div>
        </Form>
      </PageWrapper>
    );
  }
}

const getAnswers = (riskQuestions, values) => {
  return riskQuestions.map(({ id }) => ({
    question_id: id,
    answer: values[id]
  }));
};

const enhance = compose(
  connect(
    state => ({
      riskQuestions: state.recovery.riskQuestions,
      isLoading: state.recovery.isLoading,
      clocks: state.auth.user.progress.clocks,
      profile_color: state.auth.user.profile_color
    }),
    { submitRisk, getRiskQuestions }
  ),
  withRouter,
  withFormik({
    mapPropsToValues: () => ({
      date: moment(),
      shouldOpenRecovery: 'true'
    }),
    validationSchema: ({ clocks }) => {
      const minDate = clocks.last_attempt_start
        ? clocks.last_attempt_start
        : clocks.start;

      return yup.object().shape({
        isCorrectDate: yup.bool().required('Choose answer!'),
        date: yup.date().when('isCorrectDate', {
          is: value => value === 'false',
          then: yup
            .date()
            .min(
              new Date(minDate),
              "You can't set a date that is less than the previous attempt!"
            )
            .max(new Date(), "You can't set a future date!")
            .required('Date is required!')
        })
      });
    },

    handleSubmit: (
      values,
      {
        setSubmitting,
        props: { submitRisk, riskQuestions, closeModal, history }
      }
    ) => {
      values.isCorrectDate === 'false' &&
        submitRisk({
          attempt: 'failed',
          date: moment(values.date).format()
        })
          .then(() => {
            const route =
              values.shouldOpenRecovery === 'true'
                ? '/module/relapsemodule'
                : '/dashboard';
            history.push(route);
          })
          .catch(toastResponseErrors);

      values.isCorrectDate === 'true' &&
        submitRisk({ answers: getAnswers(riskQuestions, values) })
          .then(() => {
            history.push('/dashboard');
          })
          .catch(response => {
            toastResponseErrors(response);
            setSubmitting(false);
          });
    },
    displayName: 'WeeklyCheckIn'
  })
);

export default enhance(WeeklyCheckIn);



// WEBPACK FOOTER //
// ./src/containers/WeeklyCheckIn/WeeklyCheckIn.jsx